import CircleIcon from '@mui/icons-material/Circle'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined'
import { FormLabel, Tooltip, Typography, styled } from '@mui/material'
import Zoom from '@mui/material/Zoom'
import dayjs from 'dayjs'
import {
  MRT_Cell,
  MRT_Column,
  MRT_Row,
  MRT_TableInstance,
} from 'material-react-table'

import useCanAccess from 'hooks/useCanAccess'
import { useAppSelector } from 'store/hooks'
import resources from 'utils/constants/resources'
import { contentMessages } from 'utils/constants/ui'
import userActions from 'utils/constants/userActions'
import formatDateTime from 'utils/dateTime'

export const masterCellStatus = ({
  cell,
}: {
  cell: MRT_Cell<any>
  renderedCellValue: number | string | React.ReactNode
  column: MRT_Column<any>
  row: MRT_Row<any>
  table: MRT_TableInstance<any>
}) => {
  const value: any = cell.getValue()

  return (
    <Tooltip
      title={value || ''}
      color="red"
      placement="right-end"
      arrow
      TransitionComponent={Zoom}
    >
      <CircleIcon
        color={value === 'ACTIVE' ? 'success' : 'error'}
        sx={{ width: '0.8rem', marginLeft: '0.5rem' }}
      />
    </Tooltip>
  )
}

export const useCanEdit = () => {
  const resource = resources.PAY_CMS.name
  const canView = useCanAccess({ resource, action: userActions.EDIT })
  return (
    canView && (
      <Typography variant="body2" color="text.secondary">
        <EditOutlinedIcon color="primary" sx={{ fontSize: '1.5rem' }} />
      </Typography>
    )
  )
}

export const LabelStyle = styled(FormLabel)(({ theme }) => ({
  marginBottom: theme.spacing(1),
  fontSize: '1rem',
}))

export const renderMasterStatusCell = ({ cell }: { cell: MRT_Cell<any> }) => {
  const isActive = cell?.getValue() === 'ACTIVE'

  return (
    <Tooltip
      title={isActive ? 'Active' : 'Inactive'}
      color="red"
      placement="right-end"
      arrow
      TransitionComponent={Zoom}
    >
      <CircleIcon
        color={isActive ? 'success' : 'error'}
        sx={{ width: '0.8rem', marginLeft: '0.5rem' }}
      />
    </Tooltip>
  )
}

function TimeZone() {
  const timezone = useAppSelector((state) => state.timezone)
  return timezone
}

export const renderMasterLastChanged = ({ cell }: { cell: MRT_Cell<any> }) => {
  const value = cell?.getValue() as string
  const { timezone } = TimeZone()
  return (
    <Typography overflow="hidden" textOverflow="ellipsis" variant="body2">
      {dayjs(value).isValid()
        ? formatDateTime(value, timezone)
        : contentMessages.NO_DATA}
    </Typography>
  )
}
